import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Lazy-loaded for performance (matches the companyknowledge pattern).
const KnowledgeExplorer = React.lazy(() => import("./KnowledgeExplorer"));

const knowledgeExplorerModuleConfig: ModuleConfig = {
    // 🏷️ MODULE IDENTITY
    id: "knowledgeexplorer",
    name: "Knowledge Explorer",
    description:
        "Browse + chat over a synced markdown knowledge folder (file tree, Mermaid, wikilinks, attachments). Talks to the Mac Studio knowledge stack via the backend.",
    version: "0.1.0",
    enabled: true,
    category: "business",
    order: 18,
    icon: "🧭",
    color: "#0EA5E9",

    // 🛣️ ROUTES — full-bleed canvas (the page manages its own 3-pane layout).
    routes: [
        {
            path: "/knowledgeexplorer",
            component: KnowledgeExplorer,
            permissionLevel: "view", // resolved against backend knowledgeExplorerPermissions
            useLayout: true,
            layoutOptions: { noContainer: true, noFooter: true, fillViewport: true },
        },
    ],

    // 🧭 NAVIGATION
    navigation: [
        {
            label: "Knowledge Explorer",
            path: "/knowledgeexplorer",
            icon: "🧭",
            permissionLevel: "view",
        },
    ],

    // 🔐 PERMISSIONS — none registered yet; open to any logged-in user for the test.
    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },
};

export default knowledgeExplorerModuleConfig;
